import appConfigurationService from "@/Services/AppConfigurationService";

// Tipo de solicitação => módulo correspondente.
const MODULO_SOLICITACAO = {
  falta: "justificar_falta",
  atraso: "justificar_atraso",
  remoto: "registro_remoto",
};

// O store é persistido no localStorage: os módulos são revalidados uma vez por carga da página.
let carregamentoModulos = null;

const state = () => ({
  notifiqLancamentoEnabled: false,
  loading: false,
  // chave do módulo => se o usuário logado pode acessar. Módulo ausente conta como liberado.
  modulos: {},
});

const mutations = {
  setNotifiqLancamentoEnabled(state, value) {
    state.notifiqLancamentoEnabled = Boolean(value);
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setModulos(state, permitido) {
    state.modulos = { ...(permitido || {}) };
  },
};

const actions = {
  async fetchNotifiqLancamentoStatus({ commit }) {
    commit("setLoading", true);
    try {
      const data = await appConfigurationService.getNotifiqLancamentoStatus();
      commit("setNotifiqLancamentoEnabled", data.enabled ?? false);
    } catch {
      commit("setNotifiqLancamentoEnabled", false);
    } finally {
      commit("setLoading", false);
    }
  },

  /** Busca na API os módulos que o usuário logado pode acessar. */
  async fetchModulos({ commit }) {
    carregamentoModulos = appConfigurationService
      .getModulos()
      .then((data) => commit("setModulos", data.permitido))
      .catch(() => {
        // Sem resposta, mantém o último valor conhecido; a API continua barrando o acesso.
        carregamentoModulos = null;
      });
    return carregamentoModulos;
  },

  /** Garante que os módulos foram carregados nesta sessão (usado pelos guards de rota). */
  async garantirModulos({ dispatch }) {
    return carregamentoModulos || dispatch("fetchModulos");
  },
};

const getters = {
  notifiqLancamentoEnabled: (state) => state.notifiqLancamentoEnabled,
  modulos: (state) => state.modulos,
  moduloAtivo: (state) => (chave) => !chave || state.modulos?.[chave] !== false,
  podeSolicitar: (state, getters) => (tipo) => getters.moduloAtivo(MODULO_SOLICITACAO[tipo]),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
